import React from 'react';
import {
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from 'recharts';

export default function KalemlerPieChart({ periodReport, showAmount }) {
  const chartData = periodReport.products.map((item) => ({
    name: item.name,
    totalAmount: item.totalAmount,
    totalPrice: item.totalPrice,
  }));

  const COLORS = [
    '#8884d8',
    '#82ca9d',
    '#ffc658',
    '#ff8042',
    '#8dd1e1',
    '#a4de6c',
    '#d0ed57',
    '#d885a3',
    '#ad88f5',
    '#f5a142',
    '#a1c181',
    '#ffd700',
    '#ff69b4',
    '#b0e0e6',
    '#98fb98',
    '#dda0dd',
    '#ff6347',
    '#4682b4',
    '#cd5c5c',
    '#ffb6c1',
  ];

  return (
    <ResponsiveContainer width="100%" height={400}>
      <PieChart>
        <Pie
          data={chartData}
          dataKey={showAmount ? 'totalAmount' : 'totalPrice'}
          nameKey="name"
          cx="50%"
          cy="50%"
          outerRadius={150}
          fill="#82ca9d"
          label
        >
          {chartData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );
}
